module.exports = __webpack_public_path__ + "static/img/productLine.91c5bd1e.svg";